var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4998 34.2751C15.553 34.2751 11.8428 32.7386 9.05231 29.9475C6.26186 27.1564 4.72461 23.4461 4.72461 19.5C4.72461 15.5539 6.26121 11.843 9.05231 9.05255C11.8434 6.2621 15.5536 4.72485 19.4998 4.72485C23.4459 4.72485 27.1568 6.26145 29.9472 9.05255C32.7377 11.8437 34.2749 15.5539 34.2749 19.5C34.2749 23.4461 32.7383 27.157 29.9472 29.9475C27.1561 32.7379 23.4459 34.2751 19.4998 34.2751ZM19.4998 6.41485C12.2848 6.41485 6.41461 12.285 6.41461 19.5C6.41461 26.715 12.2848 32.5851 19.4998 32.5851C26.7148 32.5851 32.5849 26.715 32.5849 19.5C32.5849 12.285 26.7148 6.41485 19.4998 6.41485Z",
    fill: "#F29550"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4998 20.345C19.0331 20.345 18.6548 19.9667 18.6548 19.5V8.52212C18.6548 8.05542 19.0331 7.67712 19.4998 7.67712C19.9665 7.67712 20.3448 8.05542 20.3448 8.52212V19.5C20.3448 19.9667 19.9665 20.345 19.4998 20.345Z",
    fill: "#F29550"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4776 20.345H19.4998C19.0331 20.345 18.6548 19.9667 18.6548 19.5C18.6548 19.0333 19.0331 18.655 19.4998 18.655H30.4776C30.9443 18.655 31.3226 19.0333 31.3226 19.5C31.3226 19.9667 30.9443 20.345 30.4776 20.345Z",
    fill: "#F29550"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/Time.a2be3593331673e03c62d7fb386a6462.svg";
export { ForwardRef as ReactComponent };